import React, { useRef, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ScrollToBottom from 'react-scroll-to-bottom';
import logoLoading from '../Res/logo-loading.gif';
import { getPermissionForComponent } from '../utils/permissionsUtils';

const PingModal = ({ isOpen, onCancel, data, user }) => {
  const messageRef = useRef();
  const secureInfo = getPermissionForComponent('secureInfo', user.permissionsGroup);

  useEffect(() => {
    if (messageRef.current) {
      const container = messageRef.current.parentElement;
      const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 10;
      if (isAtBottom) {
        messageRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      }
    }
  }, [data]); 
  const isUserAllowed = () => {
    return secureInfo === 'both' || secureInfo === 'read';
  }

  return (
    <Modal isOpen={isOpen} id="ping-modal">
      <ModalHeader>Data</ModalHeader>
      <ModalBody>
        <ScrollToBottom className="ping-data-container">
          <div className="ping-container" ref={messageRef}>
            {!!data.length ? (
              data.map(item => {
                let filteredItem = item;
                if (!isUserAllowed() && item.includes('wwan0')) {
                  filteredItem = item?.replace(/ from \d+\.\d+\.\d+\.\d+ wwan0/, '');
                }
                return <p>{filteredItem}</p>;
              })
            ) : (
              <div className="ping-loading-container">
                <img src={logoLoading} className="loading-logo-sm" alt="loading" />
              </div>
            )}
          </div>
        </ScrollToBottom>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" id="ping-close-btn" onClick={onCancel}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PingModal;
